export default function createLogStream({ fetch_, config }) {
  return fetch_(`${config.AGENT_SERVICE_V2_URL}/user/create-log-stream`, {
    method: 'POST',
  });
}
